import { useEffect, useMemo } from 'react';
import { useServerContext } from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import { LoadingIndicator } from './components/loading-indicator/LoadingIndicator';
import { Redirect } from './components/redirect/Redirect';
import { isHydrated, isServer } from './utils/utils';

export const LoadFromServer: PageFC = () => {
    const { req } = useServerContext();
    useEffect(() => {
        if (isHydrated()) {
            if (window.location.href.match(/https?:\/\/localhost:3000/)) {
                window.location.assign(window.location.href.replace(/3000/, '8000'));
            } else {
                window.location.reload();
            }
        }
    }, []);

    const fullUrl = useMemo(
        () =>
            isServer && req
                ? `${req.protocol}://${req.get('host')}${req.originalUrl}`
                : window.location.href,
        [req],
    );

    if (isServer && req.url.match(/^\/s\//)) {
        // What to do with /s/* URLs?
        // This is an error scenario because this URL is not valid for PWA
        // eslint-disable-next-line no-console
        console.warn('PWA is not able to render the page, forcing the ups error page');
        throw new Error('PWA is not able to render the page');
    }

    if (isServer && !fullUrl.match(/^https?:\/\/localhost/)) {
        // One LoadFromServer in the server side means:
        // PWA is not able to render the page, so we need to redirect to the SFCC page
        // To avoid infinite redirects, we need to /s/SLT/
        // eslint-disable-next-line no-console
        console.warn('Forcing redirect to SFCC, since PWA is not able to render the page');
        return <Redirect to={`/s/SLT${req.url}`} type="sg" status={302} />;
    }
    return <LoadingIndicator isLoading />;
};
